import { DailyNewsPreviewUI } from '@doltech/modules/lib/daily-learning/data-entry/News/Steps/DailyNewsPreview';
import { withUserActivityTracking } from '@doltech/modules/lib/landing/hocs/withUserActivityTracking';
import {
  InteractionTypeEnum,
  recordResourceInteraction,
  ResourceTypeEnum,
} from '@doltech/modules/lib/management/Activity/api/activity';
import { DynamicPageProps } from '@doltech/routeDefinition';
import { ActivityTypeEnum } from '@doltech/utils/lib/constants';
import * as React from 'react';
import { useMount } from 'react-use';

interface DailyLearningNewsTemplatePageProps extends DynamicPageProps {}

const DailyLearningNewsTemplatePage = (props: DailyLearningNewsTemplatePageProps) => {
  const { pageData, ...rest } = props;

  useMount(() => {
    setTimeout(() => {
      recordResourceInteraction({
        resourceId: pageData.detailData.id,
        resourceType: ResourceTypeEnum.NEWS,
        interactionType: InteractionTypeEnum.VIEW_TEST,
      });
    }, 2000);
  });

  return (
    <DailyNewsPreviewUI
      recentNews={pageData.recentNews}
      popularNews={pageData.popularNews}
      detailData={pageData.detailData}
      excludedPopularNewsIds={pageData.excludedPopularNewsIds}
      {...rest}
    />
  );
};

export default withUserActivityTracking({ type: ActivityTypeEnum.NEWS })(
  DailyLearningNewsTemplatePage
);
